import { render, staticRenderFns } from "./LogoutConfirmation.vue?vue&type=template&id=41afe1f0&scoped=true&"
import script from "./LogoutConfirmation.vue?vue&type=script&lang=js&"
export * from "./LogoutConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41afe1f0",
  null
  
)

export default component.exports